export default {
  error_messages: {
    orders_disabled: 'Hier bestellen derzeit nicht möglich',
  },
};
